<script setup lang="ts">
import 'vue3-carousel/dist/carousel.css';
import type { PropType } from 'vue';
import { Carousel, Navigation, Pagination, Slide } from 'vue3-carousel';
import type { GetArticlesQuery } from '@shared/gql/graphql';
import { useImageUrl } from '@shared/app/composables/useImageUrl';
import { createArticleLink } from '~/utils/createArticleLink';

defineProps({
  items: {
    type: Array as PropType<GetArticlesQuery['article']>,
    required: true,
  },
});

const { createArticleImageUrl } = useImageUrl();
</script>

<template>
  <ClientOnly>
    <div class="mb-5">
      <Carousel :autoplay="3000" :wrap-around="true" class="mb-10">
        <Slide v-for="item in items" :key="item.permalink!">
          <NuxtLink
            :to="createArticleLink(item.permalink!)"
            class="block h-[260px] relative w-full"
          >
            <span
              class="bg-[#ff5a76] absolute text-white z-10 top-2 left-2 py-1.5 px-8 leading-none rounded-md"
              >やせるニュース</span
            >
            <img
              v-if="item.image_file"
              :src="
                createArticleImageUrl({
                  w: 650,
                  h: 260,
                  path: item.image_file,
                })
              "
              class="object-cover w-full h-full relative"
            />
            <AtomsPlaceholderImage
              v-else
              class="object-cover w-full h-full relative"
            />
            <span
              class="absolute bottom-0 left-0 w-full text-left bg-white/70 px-4 py-2 leading-none"
              >{{ item.title }}</span
            >
          </NuxtLink>
        </Slide>

        <template #addons>
          <Navigation class="mx-4" />
          <Pagination />
        </template>
      </Carousel>
    </div>
  </ClientOnly>
</template>

<style scoped>
.carousel {
  --vc-nav-background: #fff;
  --vc-nav-color: #66645a;
  --vc-nav-border-radius: 50%;
  --vc-nav-width: 22px;
  --vc-nav-height: 22px;

  --vc-pgn-background-color: #66645a80;
  --vc-pgn-active-color: #66645a;
  --vc-pgn-border-radius: 5px;
  --vc-pgn-height: 5px;
  --vc-pgn-width: 5px;
  --vc-pgn-gap: 24px;
  --vc-png-bottom: -18px;
}
</style>
